module.exports = require("@apollo/react-common");